/**
 * Authorization roles emitted in the OIDC profile `roles` claim.
 *
 * Centralizes the role identifiers so route guards, navigation, and feature
 * gates reference a single source of truth instead of duplicating string
 * literals. Values MUST match the claims issued by the identity provider.
 */
export const APP_ROLES = {
  ewiz: "ewiz",
  edgar: "edgar",
  hsm: "hsm",
  profileViewer: "profileviewer",
  intelligent: "intelligent",
  expert: "expert"
} as const;

export type AppRole = (typeof APP_ROLES)[keyof typeof APP_ROLES];
